import { MuiThemeProvider } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import { ErrorBoundary } from "Components/ErrorBoundary/ErrorBoundary";
import { ConnectedRouter } from "connected-react-router";
import { Provider as DIProvider } from "inversify-react";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/nova-light/theme.css";
import * as React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as ReactDOM from "react-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import { history, persistor, store } from "Store/ConfigureStore";
import MaterialUITheme from "Styles/MaterialUITheme";
import App from "./App";
import "./index.scss";
import registerServiceWorker from "./registerServiceWorker";
import "./Translations/i18n";

ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <DIProvider container={ServiceProvider}>
                <ConnectedRouter history={history}>
                    <MuiThemeProvider theme={MaterialUITheme}>
                        <PersistGate persistor={persistor}>
                            <App />
                        </PersistGate>
                    </MuiThemeProvider>
                </ConnectedRouter>
            </DIProvider>
        </Provider>
    </ErrorBoundary>,
    document.getElementById("root") as HTMLElement
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx